import React, { useEffect } from 'react';
import classes from './style.module.scss';
import Modal from '~/app/common/Modal';
import { ServiceDetails } from '~/types';
import Header from './Header';
import Form from './Form';
import { useStoreActions, useStoreState } from '~/store';

export interface CloseServiceProps {
    open: boolean
    serviceDetails?: ServiceDetails
    onSave?: (id: ServiceDetails['id']) => void
    onClose: () => void
}

export type CloseServiceComponent = React.FC<CloseServiceProps>;

const CloseService = ({ open, serviceDetails, onSave, onClose }) => {
    const costCategoryAction = useStoreActions(actions => actions.issue.fetchCostCategories);
    const fetchHPCodesAction = useStoreActions(actions => actions.issue.fetchHPCodes);
    const fetchWorkTypesAction = useStoreActions(actions => actions.issue.fetchWorkTypes);
    const fetchCustomersAction = useStoreActions(actions => actions.issue.fetchCustomers);
    const fetchProjectsAction = useStoreActions(actions => actions.projects.fetch);
    const netWorkStatus = useStoreState(state => state.app.offline.status);
    const service = useStoreState(state => state.service.data);
    const projects = useStoreState(state => state.projects.list);
    const hasSimplifiedWorkorder = useStoreState(state => state.service.hasSimplifiedWorkorder ?? false);

    useEffect(() => {
        if(!netWorkStatus && hasSimplifiedWorkorder) {
            service.departmentId && costCategoryAction(service.departmentId);
            fetchHPCodesAction();
            fetchWorkTypesAction();
            fetchCustomersAction();
            !projects?.length && fetchProjectsAction();
        }
    }, [costCategoryAction, fetchCustomersAction, fetchHPCodesAction, fetchProjectsAction, fetchWorkTypesAction, hasSimplifiedWorkorder, service.departmentId, netWorkStatus, projects?.length]);
    
    return (
        <>
            <Modal className={classes['closeIssueModel']} open={open} onClose={onClose} position={'bottom'}>
                <Header />
                <Form onClose={onClose} serviceDetails={serviceDetails} onSave={onSave} />
            </Modal>
        </>
    );
};

export default CloseService;